export interface AgendaEventModel {
  title: string
  start: Date
  end: Date
}

export enum Weekday {
  SUNDAY = 0,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THRUSDAY,
  FRIDAY,
  SATURDAY,
}

export interface TimeInterval {
  start: TimeOfDay
  end: TimeOfDay
}

export interface DateInterval {
  start: Date
  end: Date
}

export interface TimeOfDay {
  hours: number
  minutes: number
}

export interface AgendaMessages {
  disabledPastSlot: string
}

export type WeekTimeIntervals = Partial<Record<Weekday, TimeInterval[]>>
